import React from "react";
import Header from "../Dashboard/Header";
import { Link } from "react-router-dom";
import ls from "local-storage";
import * as CONFIG from "../../Components/_config";
import axios from "axios";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import ClipLoader from "react-spinners/ClipLoader";
import FooterStrict from "../Dashboard/FooterStrict";
import { renderTooltip } from "../../Components/Helper";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Analytics from "../../Assets/images/analytics.png";
// import DeleteIcon from "../../Assets/images/delete-black.jpg";

const DelIcon = React.memo(function DelIcon({ width = 20, height = 20 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      {/* Lid */}
      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      {/* Top bar */}
      <path d="M3 6h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      {/* Bin body */}
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      {/* Inner lines */}
      <path d="M10 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M14 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
});


const Loader = () => <div id="cover-spin"></div>;

const AnalysisIcon = ({ category_id, width = 25, height = 25 }) => (
  <Link to={`/category-analyzer/${category_id}`}>
    <img
      src={Analytics}
      alt="Analysis Icon"
      width={width}
      height={height}
    />
  </Link>
);

const SYNC_STATUS_CFG = {
  PENDING: { label: "Processing", bg: "#9ca3af", color: "#fff" },
  SYNCED:  { label: "Live",       bg: "#16a34a", color: "#fff" },
  FAILED:  { label: "Failed",     bg: "#dc2626", color: "#fff" },
};

const SyncStatusBadge = ({ row }) => {
  const status = row.bq_sync_status;
  if (!status) return <span style={{ color: "#9ca3af", fontSize: "12px" }}>—</span>;
  const cfg = SYNC_STATUS_CFG[status] || { label: status, bg: "#9ca3af", color: "#fff" };
  const badge = (
    <span style={{
      display: "inline-block",
      padding: "3px 10px",
      borderRadius: "12px",
      fontSize: "11px",
      fontWeight: 600,
      background: cfg.bg,
      color: cfg.color,
      letterSpacing: "0.3px",
      cursor: status === "FAILED" && row.bq_sync_error ? "help" : "default"
    }}>
      {cfg.label}
    </span>
  );
  if (status === "FAILED" && row.bq_sync_error) {
    return (
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={renderTooltip(row.bq_sync_error)}
      >
        {badge}
      </OverlayTrigger>
    );
  }
  return badge;
};


class CustomAnalysisCategories extends React.Component {
  constructor(props) {
    super(props);
    toast.configure();

    this.state = {
      UpcList: "",
      categoryLoader: true,
      loading: false,
      columns: [
        {
          name: "Name",
          // eslint-disable-next-line no-useless-escape
          selector: (row) => row.category_name.replace(/\\\\'/g, "\'"),
          sortable: true,
          left: true,
          grow: 2,
          cell: row => (
            <span style={{ 
              color: '#1f2937',
              fontSize: '14px'
            }}>
              {row.category_name.replace(/\\\\'/g, "\'")}
            </span>
          )
        },
        {
          name: "Created On",
          selector: (row) => row.created_at,
          cell: row => (
            <span style={{
              color: '#1f2937',
              fontSize: '14px'
            }}>
              {row.created_at}
            </span>
          ),
          center: true,
          ignoreRowClick: true,
          allowOverflow: true,
          button: true
        },
        {
          name: "Sync Status",
          selector: (row) => row.bq_sync_status,
          cell: row => <SyncStatusBadge row={row} />,
          center: true,
          ignoreRowClick: true,
          allowOverflow: true,
          button: true
        },
        {
          name: "EDIT",
          selector: (row) => row.category_name,
          cell: row => (
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip('Edit')}
            >
              <Link
                to={`/create-edit-custom-analysis-category/${row.category_guid}?category_id=${row.category_id}`}
              >
                EDIT
              </Link>
            </OverlayTrigger>
          ),
          center: true,
          ignoreRowClick: true,
          allowOverflow: true,
          button: true
        },
        {
          name: "DELETE",
          selector: (row) => row.category_name,
          cell: row => (
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip('Delete')}
            >
              <button
                type="button"
                aria-label="Delete Category"
                className="btn btn-outline-danger"
                style={{ 
                  background: 'transparent', 
                  color: '#ef4444', 
                  border: 'none', 
                  padding: 6, 
                  cursor: 'pointer', 
                  borderRadius: 8 
                }}
                onClick={() => this.AlertModal(String(row.category_guid), row.category_name)}
              >
                <DelIcon />
              </button>
            </OverlayTrigger>
          ),
          center: true,
          ignoreRowClick: true,
          allowOverflow: true,
          button: true
        },
        {
          name: "ANALYSIS",
          selector: (row) => row.category_name,
          cell: row => (
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip('Analysis')}
            >
              <div style={{ textAlign: 'center', width: '100%' }}>
                <AnalysisIcon category_id={row.category_id} />
              </div>
            </OverlayTrigger>
          ),
          center: true,
          ignoreRowClick: true,
          allowOverflow: true,
          button: true
        }
      ],
      customStyles: {
        table: {
          style: {
            borderRadius: 12,
            overflow: 'hidden',
            boxShadow: '0 4px 14px rgba(0,0,0,0.06)'
          }
        },
        headRow: {
          style: {
            backgroundColor: '#f8fafc',
            minHeight: '48px',
            borderTop: '1px solid #e5e7eb',
            borderBottom: '1px solid #e5e7eb'
          }
        },
        headCells: {
          style: {
            fontSize: '12px',
            color: '#334155',
            letterSpacing: '.04em',
            textTransform: 'uppercase',
            fontWeight: 600
          }
        },
        rows: {
          style: {
            minHeight: '46px'
          },
          highlightOnHoverStyle: {
            backgroundColor: 'rgba(59,130,246,0.08)',
            transition: 'background-color 0.15s ease'
          }
        },
        cells: {
          style: {
            paddingTop: '10px',
            paddingBottom: '10px'
          }
        },
        pagination: {
          style: {
            borderTop: '1px solid #e5e7eb'
          }
        }
      }
    };
  }

  changeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      formControls: {
        ...this.state.formControls,
        [name]: value
      }
    });
  };

  async componentDidMount() {
    await this.GetCustomCategories();
  }

  AlertModal(categoryguid, categoryname) {
    $("#confirmcategoryModal").trigger("click");
    this.setState({ categoryguid: String(categoryguid), categoryname: categoryname });
  }

  CreateCategory = async (e) => {

    e.preventDefault();
    //var b_guid = ls.get("brands") ? ls.get("brands")[0].guid : "";
    const b_guid = ls.get('selectedbrand') ? ls.get('selectedbrand')[0].guid : '';

    if ($("#add_category_name").val().length <= 0) {
      toast.error("First Name can't be blank", { theme: "colored" });
      return false;
    }
    else {

      $("#exampleModal").css("display", "none");
      $(".modal-backdrop").first().css("display", "none");
      this.showLoader();

      var data = JSON.stringify({
        category_name: this.state.formControls.add_category_name.trim(),
      });

      var config = {
        method: "post",
        url: CONFIG.API_URL + `brand/customcategory/${b_guid}`,
        headers: CONFIG.config_head.headers,
        data: data
      };
      axios(config)
        .then((res) => {
          if (res.status === 200) {
            toast.success('Custom Category Added Successfully')
            this.hideLoader();
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 403) {
              this.hideLoader();
              toast.error(error.response.data.Message);
              ls.clear("token");
              ls.clear("brands");
              window.location.href = "/login";
            }
            else {
              this.hideLoader();
              toast.error(error.response.data.Message);
            }
          }
        });
    }
  }
  
  GetCustomCategories = async () => {
    const guid = ls.get('selectedbrand') ? ls.get('selectedbrand')[0].guid : '';
    var data = "";
    var config = {
      method: "get",
      url: CONFIG.API_URL + `brand/customcategory/${guid}`,
      headers: CONFIG.config_head.headers,
      data: data
    };
    axios(config)
      .then((response) => {
        this.setState({ tableData: response.data.Message, Categorylist: response.data.Message, categoryLoader: false });
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 400) {
            this.setState({ tableData: '', Categorylist: '', categoryLoader: false })
            toast.error(error.response.data.Message);

          } else if (error.response.status === 403) {
            toast.error(error.response.data.Message);
            ls.clear("token");
            ls.clear("brands");
            window.location.href = "/login";
          } else {
            toast.error(error.response.data.Message);
          }
        }
      });
  }

  RemoveCategory(category_guid, category_name) {
    category_guid = String(category_guid);
    const guid = ls.get('selectedbrand') ? ls.get('selectedbrand')[0].guid : '';

    $("#staticBackdropcategory").css("display", "none");
    $(".modal-backdrop").first().css("display", "none");

    this.showLoader();
    var data = JSON.stringify({
      category_name: category_name,
      category_status: 0,
    });
    var config = {
      method: "put",
      url: CONFIG.API_URL + `brand/customcategory/${guid}/${category_guid}`,
      headers: CONFIG.config_head.headers,
      data: data
    };

    axios(config)
      .then(async (res) => {
        if (res.status === 200) {
          this.hideLoader()
          toast.success("Custom Category Removed Successfully");
          await this.GetCustomCategories();
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 502) {
            this.hideLoader()
            toast.error("Bad Request, Please Try Again!");
          } else if (error.response.status === 403) {
            this.hideLoader()
            toast.error(error.response.data.Message);
            ls.clear("token");
            ls.clear("brands");
            window.location.href = "/login";
          } else {
            this.hideLoader()
            toast.error(error.response.data.Message);
          }
        }
      });
  }


  showLoader = () => {
    this.setState({ loading: true });
  }
  hideLoader = () => {
    this.setState({ loading: false });
  };

  render() {
    return (
      <>
        <Header location={`category`} />
        {this.state.loading ? <Loader /> : null}

        <section className="ContentBlock  pt-24 pb-24 Main_Block">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className=" col-12">
                     <div className="Coupons_Block mt-10">
                  <div className="Card Coupons w-100" style={{ borderRadius: 6, overflow: 'hidden', border: '1px solid #e5e7eb'}}>
                    <div className="Card_Header" style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'space-between', 
                      padding: '14px 16px', 
                      background: '#3d8ecc',
                      color: '#fff' 
                    }}>
                      <h5 style={{ margin: 0, fontSize: '16px', fontWeight: 600 }}> Competitive Analysis</h5>
                      <div className="Card_Header_Right">
                         <Link
                          to="/competitive-analysis"
                          className="btn btn-primary"
                          style={{
                            background: "#fff",
                            color: "#3d8ecc",
                            border: "none",
                            fontWeight: 700,
                            padding: "8px 16px",
                            borderRadius: "6px",
                            textDecoration: "none",
                            fontSize: "14px",
                            marginRight: "10px"
                          }}
                        >
                          &lt;&lt; Back to Competitive Analysis
                        </Link>
                        <Link 
                          to="/create-edit-custom-analysis-category" 
                          className="btn btn-primary"
                          style={{
                            background: '#fff',
                            color: '#3d8ecc',
                            border: 'none',
                            fontWeight: 700,
                            padding: '8px 16px',
                            borderRadius: '6px',
                            textDecoration: 'none',
                            fontSize: '14px'
                          }}
                        >
                          + Create Category for Analysis
                        </Link>
                      </div>
                    </div>
                 </div>
                  <div className="Common_Block_Body">
                    {
                      this.state.categoryLoader ? (
                        <div className="Clip_Loader" style={{ minHeight: "280px" }}>
                          <ClipLoader color={"rgb(0, 143, 251)"} loading={true} size={50} />
                        </div>
                      ) :
                        <div className="table-responsive Coupons_Table categories-table-view">
                          {this.state.Categorylist ? (
                            <>
                              <DataTable
                                columns={this.state.columns}
                                data={this.state.tableData}
                                customStyles={this.state.customStyles}
                                highlightOnHover
                                striped
                                dense
                                pagination
                                noDataComponent={<span style={{ color: '#6b7280' }}>No categories found</span>}
                              />
                            </>
                          ) : (
                            <div style={{ 
                              textAlign: 'center', 
                              padding: '40px 20px', 
                              color: '#6b7280', 
                              fontSize: '14px',
                              fontWeight: 500
                            }}>
                              No categories available for this brand
                            </div>
                          )}
                        </div>
                    }
                    <div className="d-flex align-items-center justify-content-end Pagination_Block"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <button
            className="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdropcategory"
            id="confirmcategoryModal"
            style={{ display: "none" }}
          >
            Alert
          </button>

          <div
            className="modal fade Confirmation_Modal"
            id="staticBackdropcategory"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <i className="fas fa-exclamation-triangle text-center "></i>
                  <h4 className="mt-20 fw-bold text-center">Are you sure?</h4>
                  <p className="mt-10 text-center">
                    You want to delete this selected category.
                  </p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={(e) =>
                      this.RemoveCategory(
                        this.state.categoryguid ? this.state.categoryguid : "", this.state.categoryname ? this.state.categoryname : ""
                      )
                    }
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>


          {/* BEGIN:ADD USER MODAL */}

          <div className="modal fade Add_User_Modal" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">ADD CATEGORY</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <form className="row gx-4 gy-3" method="post">
                  <>
                    <div className="modal-body">
                      <div className="col-12">
                        <label
                          htmlFor="inputEmail4"
                          className="form-label"
                        >
                          Category Name
                        </label>

                        <input type="text" className="form-control" placeholder="Category Name" name="add_category_name"
                          id="add_category_name" onChange={this.changeHandler} />
                      </div>
                    </div>

                    <div className="modal-footer justify-content-center">
                      <button type="submit" className="btn Btn_blue w-fit-content px-4 py-2 rounded-2" onClick={(e) => { this.CreateCategory(e); }}>Save</button>


                    </div>
                  </>
                </form>
              </div>

            </div>
          </div>

          {/* END:ADD USER MODAL */}

        </section>
        <FooterStrict />
      </>
    );
  }
}
export default CustomAnalysisCategories;
